import { toast } from "react-toastify";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";
import {  GET_STATION_REVENUE_TREND_API } from "../../constants/constants";
import { fetchStationRevenueTrendFailure, fetchStationRevenueTrendSuccess} from "./reducer";

export const getAllStationRevenueTrend =
  (stationId, setLoading, dateRange) => async (dispatch) => {
    setLoading(true);
    await determineBaseUrlAndPerformApiCall(
      `${GET_STATION_REVENUE_TREND_API}/${stationId}?unit=Wh&period=${
        dateRange?.period || "3m"
      }${
        dateRange?.period === "custom"
          ? `&from=${dateRange?.from}&to=${dateRange?.to}`
          : ""
      }`,
      "GET"
    )
      .then((response) => {
        setLoading(false);
          if (response === null || response === undefined) {
          dispatch(fetchStationRevenueTrendSuccess([]));
          return;
        }
        if (!response.error) {
          dispatch(fetchStationRevenueTrendSuccess(response || []));
          // dispatch(setSuccessMessage(true));
        }
        if (response.error) {
          if (response.error.code === "NotFound") {
            dispatch(fetchStationRevenueTrendSuccess([]));
          } else {
            dispatch(fetchStationRevenueTrendFailure(response.error.message));
            toast.error(`${response.error.message}`);
          }
        }
      })
      .catch((errorResp) => {});
  };
